import React, { useEffect, useState } from 'react';
import axios from 'axios';
import CallController from '../API/CallController';
import '../scss/Home.scss';
import '../scss/responsive.scss';

interface ProductWithIdDto {
  id: number;
  name: string;
  description: string;
  price: number;
  discountedPrice?: number;
  imageUrl?: string | null;
  priceUnit: string;
}

interface CampaignDto {
  id: number;
  title: string;
  description: string;
  startDate: string;
  endDate: string;
  products: ProductWithIdDto[];
}

const ActiveCampaign: React.FC = () => {
  const [campaign, setCampaign] = useState<CampaignDto | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);

// Method to fetch the active campaign for the front page (for visitors)
  useEffect(() => {
    const fetchCampaigns = async () => {
      try {
        const res = await axios.get<CampaignDto[]>(CallController.GetAllCampaigns);
        const now = new Date();
        const activeCampaign = res.data.find(c =>
          new Date(c.startDate) <= now && now <= new Date(c.endDate)
        );
        if (activeCampaign) {
          setCampaign(activeCampaign);
        } else {
          setError('');
        }
      } catch (err: any) {
        setError(err.message || 'Något gick fel vid hämtning av kampanjer.');
      } finally {
        setLoading(false);
      }
    };

    fetchCampaigns();
  }, []);

  if (loading) return <p className="loading">Laddar kampanj...</p>;
  if (error) return <p className="error">{error}</p>;
  if (!campaign) return null;

  return (
    <section className="active-campaign">
      <header className="campaign-header">
        <h2>{campaign.title}</h2>
        <p>{campaign.description}</p>
        <p className="campaign-period">
          <strong>Gäller till och med:</strong> {campaign.endDate.slice(0, 10)}
        </p>
      </header>

      <div className="campaign-products">
        {campaign.products.length === 0 && <p className="no-products">Inga produkter i kampanjen.</p>}
        {campaign.products.map(p => (
          <article key={p.id} className="campaign-product">
            <div className="image-wrapper">
              {p.imageUrl ? (
                <img
                  src={`https://accordi-web-eqb2byhxd0feffhu.norwayeast-01.azurewebsites.net${p.imageUrl}`}
                  alt={p.name}
                  onError={(e) => { (e.target as HTMLImageElement).src = '/images/default-product.png'; }}
                />
              ) : (
                <img src="/images/default-product.png" alt="Standardprodukt" />
              )}
            </div>
            <h4>{p.name}</h4>
            <p className="price">
              {p.discountedPrice && p.discountedPrice < p.price ? (
                <>
                  <span className="original-price">
                    {p.price} {p.priceUnit}
                  </span>
                  <span className="discounted-price">
                    {p.discountedPrice} {p.priceUnit}
                  </span>
                </>
              ) : (
                <span>
                  {p.price} {p.priceUnit}
                </span>
              )}
            </p>

          </article>
        ))}
      </div>
    </section>
  );
};

export default ActiveCampaign;
